import { Routes, Route } from "react-router-dom"
import Files from "./pages/Files"
import NotFoundError from "../../components/Alerts/NotFoundError"
import IndividualFile from "./pages/IndividualFile";

export default function FilesRoutes() {

    return (
        <Routes>
            <Route index element={<Files />} />
            <Route path=':id' element={<IndividualFile />} />
            <Route path='404' element={<NotFoundError />} />
        </Routes>
    )
}